
// src/reportWebVitals.ts
// We’re not using web-vitals in this app, so this is a no-op stub.
// This avoids version / typing mismatches with the web-vitals package.

const reportWebVitals = () => {
  // Intentionally empty
};

export default reportWebVitals;
